import {useSyncExternalStore} from 'react'
import {AGENT_TASKS_REASONING_EFFORT_KEY} from '../utils/constants'
import {isReasoningEffort, type ReasoningEffort} from '@github-ui/copilot-shared-ui/utils/reasoning-effort'

function subscribe(callback: () => void) {
  const handleStorageChange = (e: StorageEvent) => {
    // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic
    if (e.key === AGENT_TASKS_REASONING_EFFORT_KEY) {
      callback()
    }
  }
  window.addEventListener('storage', handleStorageChange)
  return () => window.removeEventListener('storage', handleStorageChange)
}

function getSnapshot() {
  try {
    const stored = localStorage.getItem(AGENT_TASKS_REASONING_EFFORT_KEY)
    return isReasoningEffort(stored) ? stored : undefined
  } catch {
    return undefined
  }
}

function getServerSnapshot() {
  return undefined
}

function setLatestReasoningEffort(newValue: ReasoningEffort | undefined) {
  try {
    const oldValue = localStorage.getItem(AGENT_TASKS_REASONING_EFFORT_KEY)
    if (newValue === undefined) {
      localStorage.removeItem(AGENT_TASKS_REASONING_EFFORT_KEY)
    } else {
      localStorage.setItem(AGENT_TASKS_REASONING_EFFORT_KEY, newValue)
    }
    window.dispatchEvent(
      new StorageEvent('storage', {
        key: AGENT_TASKS_REASONING_EFFORT_KEY,
        newValue: newValue ?? null,
        oldValue,
      }),
    )
  } catch {
    // localStorage not available
  }
}

export function useLatestReasoningEffort(): [
  ReasoningEffort | undefined,
  (value: ReasoningEffort | undefined) => void,
] {
  const value = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

  return [value, setLatestReasoningEffort]
}
